import React from 'react';
import TableWrapServerSide from '@/components/ui/tables/TableWrapServerSide';
import IsLoadingNotFound from '@/components/ui/tables/IsLoadingNotFound';
import { Link } from 'react-router-dom';
import PermissionCheck from '@/components/common/PermissionCheck';

const DataTable = ({
  isLoading,
  tableColumn,
  dataSource,
  totalRecord,
  dataFilter,
  onChangePage,
  handleDrawerOpen,
  deleteRecord,
  showBranchCol = false,
}) => (
  <TableWrapServerSide
    tableColumnList={tableColumn}
    totalDataCount={totalRecord}
    initialPage={dataFilter?.page}
    onChangePage={onChangePage}
    per_page={dataFilter?.limit}
  >
    {dataSource && dataSource.length > 0 ? (
      dataSource.map((row) => (
        <tr className="db-table-body-tr" key={row._id}>
          <td className="db-table-body-td">{row.name}</td>
          <td className="db-table-body-td">{row.size}</td>
          {showBranchCol && <td className="db-table-body-td">{row.branch?.name || '—'}</td>}
          <td className="db-table-body-td">
            {Number(row.status) === 1 ? <span className="active">Active</span> : <span className="inactive">Inactive</span>}
          </td>
          <td className="db-table-body-td hidden-print hidden-print-remove">
            <div className="flex justify-start items-center gap-1.5">
              <PermissionCheck permsission="view_dining_tables">
                <Link to={`/admin/dining-tables/show/${row._id}`}>
                  <button className="db-table-action view">
                    <i className="lab lab-view" />
                    <span className="db-tooltip">view</span>
                  </button>
                </Link>
              </PermissionCheck>
              <PermissionCheck permsission="update_dining_tables">
                <button data-modal="#sidebar" className="db-table-action edit" onClick={() => handleDrawerOpen(row._id)}>
                  <i className="lab lab-edit-line" />
                  <span className="db-tooltip">edit</span>
                </button>
              </PermissionCheck>
              <PermissionCheck permsission="delete_dining_tables">
                <button className="db-table-action delete" onClick={() => deleteRecord(row._id)}>
                  <i className="lab lab-delete" />
                  <span className="db-tooltip">delete</span>
                </button>
              </PermissionCheck>
            </div>
          </td>
        </tr>
      ))
    ) : (
      <IsLoadingNotFound isLoading={isLoading} colSpan={tableColumn.length} />
    )}
  </TableWrapServerSide>
);

export default DataTable;
